export const SET_CURRENT_CHAT_TARGET = 'SET_CURRENT_CHAT_TARGET';
export const SET_CURRENT_CHAT_TYPE = 'SET_CURRENT_CHAT_TYPE';
export const SET_IS_CHATTING_WITH_CHAT = 'SET_IS_CHATTING_WITH_CHAT';
